/*
 * GamePage
 *
 * List all the features
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import App from './App';

const scope = 'game.index';
function GamePage(props) {
  const { formatMessage } = props.intl;
  return (
    <div style={{width: "100%", height: "100vh", position: "relative"}}>
      <Helmet>
        <title>
          {formatMessage({ id: `${scope}.title`, defaultMessage: '带鱼牌' })}
        </title>
        <meta
          name="description"
          content="Feature page of React.js Boilerplate application"
        />
      </Helmet>
      {/* <H1> */}
      {/*  <FormattedMessage id={`${scope}.header`} defaultMessage="Features" /> */}
      {/* </H1> */}
      <App />
    </div>
  );
}

GamePage.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(GamePage);
